import { Component, OnInit } from '@angular/core'
import { NotificationService } from '../../../../../app/services/notification.service'
import { Router } from '@angular/router'
import { InventorAnswers, PlantingOpportunityScheduler } from 'src/app/models/Planting'
import { PlantingService } from 'src/app/services/planting.service'
import {
	setLastValuesForSchedulePlanting,
	getLastValuesForSchedulePlanting,
	getLoggedUser
} from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { Subject } from 'rxjs'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { RegionsService } from 'src/app/services/regions.service'
import { ISpecies } from 'src/app/models/Species'
import { IHandlerOperation } from 'src/app/models/HandlerOperation'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { CompanyServiceProvider } from 'src/app/models/CompanyServiceProvider'
import { CompanyServiceProviderService } from 'src/app/services/company-service-provider'

@Component({
	selector: 'app-general-feature',
	templateUrl: './general-features.component.html'
})
export class GeneralFeatures implements OnInit {

	constructor(
		private readonly plantingServide: PlantingService,
		public readonly notificationService: NotificationService,
		private readonly router: Router,
		private readonly handlerOperationService: HandlerOperationService,
		private companyServiceProviderService: CompanyServiceProviderService
	) {
		this.searchSpecie.pipe(
			debounceTime(400),
			distinctUntilChanged())
			.subscribe(value => {
				this.onChangeSearch(value)
			})
	}

	public companyId: string = localStorage.getItem('companyId')
	public sessionUser: UserAdmin = getLoggedUser()

	public plantingOpportunitySchedulerMany: Array<string> = []
	public plantingOpportunity: Array<PlantingOpportunityScheduler> = []
	public speciesSearchList: Array<ISpecies> = []
	public handlerOperations: Array<IHandlerOperation> = []
	public companiesServiceProvider: Array<CompanyServiceProvider> = []
	public handleOperationsPlantingSelected: Array<string> = []
	public plantingOpportunityIndex: number = 0
	public editingAnswerIndex: number = 0

	public newObservation: string = ''
	public selectedAnswer: InventorAnswers

	public enableNextPlanting: boolean = false
	public firstTimeEditingPlantingOpportunity: boolean = true
	public showSelectHandleOperations: boolean = false
	public showSelectCompanyProvider: boolean = false
	public editObservation: boolean = false

	public carouselPages: number = 0
	public carouselPageNow: number = 0
	public arrowLeftEnable: boolean = false
	public arrowRightEnable: boolean = true
	public photoFromCarouselEnable: boolean = false
	public photoFromCarousel_Location: boolean = false
	public photoFromCarousel: object = {}

	public speciesList: boolean = false
	public modalDetailsSpecie: boolean = false
	public specieInPanel: boolean = false
	public searchSpecieValue: string = ''
	public searchSpecie: Subject<string> = new Subject<string>()
	public specieSelected: ISpecies = {}
	public srcImageSpecieSelected: string

	public async ngOnInit(): Promise<void> {
		const topPage = document.getElementsByClassName('main-content')[0]

		topPage.scrollIntoView({
			behavior: 'smooth'
		})

		localStorage.removeItem('operationService')
		localStorage.removeItem('demand')

		await this.getPlantingOpportunityDetails()
		await this.getHandlerOperations()
		await this.getCompaniesServiceProvider()
	}

	public async getPlantingOpportunityDetails() {

		this.plantingOpportunitySchedulerMany = JSON.parse(localStorage.getItem('planting'))

		this.plantingOpportunity =
			await this.plantingServide.getPlantingScheduling(this.plantingOpportunitySchedulerMany).toPromise()

		this.plantingOpportunity.forEach(plantingOpportunity => {
			plantingOpportunity.userCreatorId = this.sessionUser._id
			plantingOpportunity.characterizationCode = 1
			plantingOpportunity.height = getLastValuesForSchedulePlanting('lastHeight')
			plantingOpportunity.fuste.value = getLastValuesForSchedulePlanting('lastFuste')
			plantingOpportunity.cupProjection = getLastValuesForSchedulePlanting('lastCupProjection')
			plantingOpportunity.dapCapCharacterization.values = getLastValuesForSchedulePlanting('lastDap')
		})

		this.setHandleOperationsPlantingSelected()
	}

	public async getHandlerOperations(): Promise<void> {
		const handleOperations: Array<IHandlerOperation> =
			await this.handlerOperationService.list(this.companyId, false, 'Planting').toPromise()

		const operations = handleOperations.map(item => {
			return {
				operation: item.operation,
				_id: item._id
			}
		})
		this.handlerOperations = operations
	}

	public async getCompaniesServiceProvider(): Promise<void> {
		try {
			this.companiesServiceProvider =
				await this.companyServiceProviderService.getCompaniesServiceProvider({
					companyId: this.companyId,
					skip: 0,
					limit: 100,
					order: 'CNPJ',
					typeOrder: 'desc'
				}).toPromise()
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public async onChangeSearch(valueSearch: string) {
		try {
			if (!valueSearch.trim() || valueSearch.trim().length < 2) {
				return
			}

			this.plantingServide.getSpecies(valueSearch).subscribe(result => {
				this.speciesSearchList = result.content
				this.speciesList = true
			})

		} catch (error) {
			console.log(error, 'Erro ao buscar espécies')
		}
	}

	public selectSpecie(specie: ISpecies) {
		this.specieSelected = specie
		this.srcImageSpecieSelected = this.specieSelected.gallery[0]

		this.speciesList = false
		this.specieInPanel = true

		if (this.firstTimeEditingPlantingOpportunity) {
			this.plantingOpportunity.forEach(plantingOpportunity => {
				plantingOpportunity.specieId = this.specieSelected._id
				plantingOpportunity.specieSelected = specie
			})
		} else {
			this.plantingOpportunity[this.plantingOpportunityIndex].specieId = this.specieSelected._id
			this.plantingOpportunity[this.plantingOpportunityIndex].specieSelected = specie
		}

		this.searchSpecieValue = ''
	}

	public removeSpecieList() {
		this.speciesList = false
	}

	public openClosemodalDetailsSpecie() {
		this.modalDetailsSpecie = !this.modalDetailsSpecie
	}

	public async returnSchedule() {
		this.router.navigate(['/panel/planting/scheduler-planting'])
	}

	public openSelectCompanyProvider() {
		if (this.companiesServiceProvider.length === 1) {
			this.plantingOpportunity.forEach(plantingOpportunity => {
				plantingOpportunity.companyProviderId = this.companiesServiceProvider[0].idMongo
			})
			this.sendToManagment()
		} else {
			this.showSelectCompanyProvider = true
		}
	}

	public closeSelectCompanyProvider() {
		this.showSelectCompanyProvider = false
	}

	public selectCompanyProvider(companyProvider: CompanyServiceProvider) {
		this.plantingOpportunity.forEach(plantingOpportunity => {
			plantingOpportunity.companyProviderId = companyProvider.idMongo
		})
		this.closeSelectCompanyProvider()
		this.sendToManagment()
	}

	public async sendToManagment() {
		this.notificationService.initLoading()

		this.plantingOpportunity.forEach(plantingOpportunity => {
			plantingOpportunity.dapCapCharacterization.average = plantingOpportunity.dapCapCharacterization.values
		})

		setLastValuesForSchedulePlanting(
			this.plantingOpportunity[0].height,
			this.plantingOpportunity[0].fuste.value,
			this.plantingOpportunity[0].cupProjection,
			this.plantingOpportunity[0].dapCapCharacterization.values
		)

		const body: Array<PlantingOpportunityScheduler> = []

		this.plantingOpportunity.forEach(plantingOpportunity => {
			const {
				localPhoto,
				imageGallery,
				specieSelected,
				...objMapped
			} = plantingOpportunity

			body.push(objMapped)
		})

		try {
			const response: any =
				await this.plantingServide.operationScheduler(body).toPromise()

			this.notificationService.notify(response.message, 200)

			localStorage.removeItem('planing')
			this.router.navigate(['/panel/planting/scheduler-planting'])
		} catch (err) {
			console.log(err)
		}

		this.notificationService.stopLoading()
	}

	public onChangeInputMensurament(event: { fieldName: string, value: number }) {
		if (this.firstTimeEditingPlantingOpportunity) {
			this.onChangeInputMensuramentInAllPlantingOpportunity(event.fieldName, event.value)

			return
		}

		if (event.fieldName == 'height') {
			this.plantingOpportunity[this.plantingOpportunityIndex].height = event.value
		}
		if (event.fieldName == 'cupProjection') {
			this.plantingOpportunity[this.plantingOpportunityIndex].cupProjection = event.value
		}
		if (event.fieldName == 'fuste') {
			this.plantingOpportunity[this.plantingOpportunityIndex].fuste.value = event.value
		}
		if (event.fieldName == 'dap') {
			this.plantingOpportunity[this.plantingOpportunityIndex].dapCapCharacterization.values = event.value
		}
	}

	public onChangeInputMensuramentInAllPlantingOpportunity(fieldName: string, value: number) {
		if (fieldName == 'height') {
			this.plantingOpportunity.forEach(plantingOpportunity => {
				plantingOpportunity.height = value
			})
		}
		if (fieldName == 'cupProjection') {
			this.plantingOpportunity.forEach(plantingOpportunity => {
				plantingOpportunity.cupProjection = value
			})
		}
		if (fieldName == 'fuste') {
			this.plantingOpportunity.forEach(plantingOpportunity => {
				plantingOpportunity.fuste.value = value
			})
		}
		if (fieldName == 'dap') {
			this.plantingOpportunity.forEach(plantingOpportunity => {
				plantingOpportunity.dapCapCharacterization.values = value
			})
		}
	}

	public moveCarousel(direction: string) {
		const carousel = document.getElementById('photos-content')
		const carouselWidth = 1176

		if (direction == 'left') {
			if (this.carouselPageNow + this.carouselPages == 0) {
				this.carouselPageNow = this.carouselPageNow
			} else {
				this.carouselPageNow--
				this.arrowLeftEnable = true
			}
			carousel.style.marginLeft = `${carouselWidth * this.carouselPageNow}px`
		} else {
			if (this.carouselPageNow < 0) {
				this.carouselPageNow++
				this.arrowRightEnable = true
			} else {
				this.carouselPageNow = this.carouselPageNow
			}
			carousel.style.marginLeft = `${carouselWidth * this.carouselPageNow}px`
		}

		if (this.carouselPageNow + this.carouselPages == 0) {
			this.arrowRightEnable = false
		}
		if (this.carouselPageNow == 0) {
			this.arrowLeftEnable = false
		}
	}

	public disableNextPlanting() {
		if (
			this.plantingOpportunity[this.plantingOpportunityIndex].height !== 0 &&
			this.plantingOpportunity[this.plantingOpportunityIndex].fuste.value !== 0 &&
			this.plantingOpportunity[this.plantingOpportunityIndex].cupProjection !== 0 &&
			this.plantingOpportunity[this.plantingOpportunityIndex].dapCapCharacterization &&
			this.plantingOpportunity[this.plantingOpportunityIndex].dapCapCharacterization.values !== null &&
			this.plantingOpportunity[this.plantingOpportunityIndex].specieId !== undefined &&
			this.plantingOpportunity[this.plantingOpportunityIndex].specieId !== '' &&
			this.plantingOpportunity[this.plantingOpportunityIndex].fuste.typeCharacterization !== undefined &&
			this.plantingOpportunity[this.plantingOpportunityIndex].fuste.typeCharacterization !== ''
		) {
			return false
		} else {
			return true
		}
	}

	public disableSendToManagment() {
		const enabledSendToManagment: boolean =
			this.plantingOpportunity.every(plantingOpportunity => {
				return (
					plantingOpportunity.height !== 0 &&
					plantingOpportunity.fuste.value !== 0 &&
					plantingOpportunity.cupProjection !== 0 &&
					plantingOpportunity.dapCapCharacterization &&
					plantingOpportunity.dapCapCharacterization.values !== null &&
					plantingOpportunity.specieId !== undefined &&
					plantingOpportunity.specieId !== '' &&
					plantingOpportunity.fuste.typeCharacterization !== undefined &&
					plantingOpportunity.fuste.typeCharacterization !== ''
				)
			})

		return enabledSendToManagment
	}

	public setHandleOperationsPlantingSelected() {
		const handleOperartions: Array<string> = []

		this.plantingOpportunity[this.plantingOpportunityIndex].handleOperations.forEach(operations => {
			handleOperartions.push(operations.operation)
		})

		this.handleOperationsPlantingSelected = handleOperartions
	}

	public editInventorAnswerObservations(index: number) {
		this.editObservation = true
		this.editingAnswerIndex = index
		this.newObservation = this.plantingOpportunity[this.plantingOpportunityIndex].inventorAnswers[index].other || ''

		this.selectedAnswer = this.plantingOpportunity[this.plantingOpportunityIndex].inventorAnswers[index]

		removeToolTip()
	}

	public saveObservation() {
		this.plantingOpportunity[this.plantingOpportunityIndex]
			.inventorAnswers[this.editingAnswerIndex]
			.other = this.newObservation

		this.newObservation = ''
		this.editObservation = false
		this.editingAnswerIndex = null
		removeToolTip()
	}

	public cancelEdit() {
		this.newObservation = ''
		this.editObservation = false
		this.editingAnswerIndex = null
		removeToolTip()
	}

	public previousPlanting() {
		if (this.plantingOpportunityIndex > 0) {
			this.plantingOpportunityIndex--

			this.scrollUpToTabSteps()
			this.switchSpecie()
			this.setHandleOperationsPlantingSelected()
		}
	}

	public nextPlanting() {
		if (
			this.plantingOpportunityIndex < this.plantingOpportunity.length - 1
		) {
			this.plantingOpportunityIndex++

			this.scrollUpToTabSteps()
			this.switchSpecie()
			this.setHandleOperationsPlantingSelected()

			this.firstTimeEditingPlantingOpportunity = false
		}
	}

	public scrollUpToTabSteps() {
		const gallery: HTMLDivElement = document.getElementById('galery-Photo') as HTMLDivElement;

		if (gallery) {
			gallery.scrollIntoView({
				behavior: 'smooth'
			});
		}	
	}

	public switchSpecie() {
		if (this.plantingOpportunity[this.plantingOpportunityIndex].specieSelected) {
			this.specieInPanel = true

			this.specieSelected =
				this.plantingOpportunity[this.plantingOpportunityIndex].specieSelected

		} else {
			this.specieInPanel = false
		}
	}

	public openClosePhotoFromCarousel(answer: object) {
		this.photoFromCarouselEnable = !this.photoFromCarouselEnable
		this.photoFromCarousel = answer

		removeToolTip()
	}

	public openClosePhotoFromCarousel_location() {
		this.photoFromCarouselEnable = !this.photoFromCarouselEnable

		this.photoFromCarousel = {
			image: this.plantingOpportunity[this.plantingOpportunityIndex].localPhoto,
			evaluation: 'Foto do local'
		}
	}

	public openSelectorHandlerOperations() {
		this.showSelectHandleOperations = true
	}

	public closeSelectorHandlerOperations(
		event: Array<{
			idMongo: string,
			operation: string,
			legalFundamentation?: string;
		}>
	) {
		this.showSelectHandleOperations = false
		this.plantingOpportunity[this.plantingOpportunityIndex].handleOperations = event
		this.setHandleOperationsPlantingSelected()
	}
}
